var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { isServer } from "../environments";
import { TravelError } from "../errors";
export var delay = function (delay) {
    if (delay === void 0) { delay = 0; }
    return new Promise(function (resolve, reject) { return setTimeout(resolve, delay); });
};
var DEFAULT_FETCHER_REQUEST = {
    lang: "en-US",
};
export function fetcher(url_1, init_1, request_1) {
    return __awaiter(this, arguments, void 0, function (url, init, request, _a) {
        var requestInit, headers, response, data, _b, code, message, error_1;
        var _c, _d, _e, _f, _g, _h;
        var _j = _a === void 0 ? {} : _a, sourceCode = _j.sourceCode, _k = _j.partnerID, partnerID = _k === void 0 ? process.env.NEXT_PUBLIC_PARTNER_ID : _k, _l = _j.json, json = _l === void 0 ? true : _l;
        return __generator(this, function (_m) {
            switch (_m.label) {
                case 0:
                    requestInit = __assign({}, init);
                    headers = new Headers({
                        partnerId: partnerID || "",
                    });
                    if (request === null || request === void 0 ? void 0 : request.campaign) {
                        headers.append("CampaignId", request.campaign);
                        delete request.campaign;
                    }
                    if (request === null || request === void 0 ? void 0 : request.ad) {
                        headers.append("AdId", request.ad);
                        delete request.ad;
                    }
                    if (request === null || request === void 0 ? void 0 : request.cid) {
                        headers.append("CId", request.cid);
                        delete request.cid;
                    }
                    if (!(init === null || init === void 0 ? void 0 : init.cache) && !((_c = init === null || init === void 0 ? void 0 : init.next) === null || _c === void 0 ? void 0 : _c.revalidate)) {
                        requestInit.cache = "force-cache";
                    }
                    if (!((_d = init === null || init === void 0 ? void 0 : init.method) === null || _d === void 0 ? void 0 : _d.match(/get/i)) && request) {
                        requestInit.body = JSON.stringify(request);
                        headers.append("Content-Type", "application/json");
                    }
                    requestInit.headers = headers;
                    if (isServer) {
                        console.log("fetch ->", url);
                    }
                    _m.label = 1;
                case 1:
                    _m.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, fetch(url, requestInit)];
                case 2:
                    response = _m.sent();
                    if (!json) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    _b = _m.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _b = response.text();
                    _m.label = 5;
                case 5:
                    data = _b;
                    if (!response.ok || (data === null || data === void 0 ? void 0 : data.status) === 500) {
                        code = ((_e = data === null || data === void 0 ? void 0 : data.response) === null || _e === void 0 ? void 0 : _e.status_code) ||
                            ((_f = data === null || data === void 0 ? void 0 : data.message) === null || _f === void 0 ? void 0 : _f.status_code) ||
                            (data === null || data === void 0 ? void 0 : data.statusCode) ||
                            (data === null || data === void 0 ? void 0 : data.status_code);
                        message = ((_g = data === null || data === void 0 ? void 0 : data.response) === null || _g === void 0 ? void 0 : _g.status) ||
                            ((_h = data === null || data === void 0 ? void 0 : data.message) === null || _h === void 0 ? void 0 : _h.status) ||
                            (data === null || data === void 0 ? void 0 : data.message) ||
                            (data === null || data === void 0 ? void 0 : data.status);
                        throw new TravelError({
                            code: code,
                            source: sourceCode,
                            message: "".concat(code ? "[".concat(code, "] ") : " ").concat(message),
                            info: data,
                            status: response.status,
                            url: url,
                            request: request,
                            partnerID: partnerID,
                        });
                    }
                    if (data.error) {
                        throw new TravelError({
                            source: sourceCode,
                            message: data.error,
                            url: url,
                            request: request,
                            partnerID: partnerID,
                        });
                    }
                    return [2 /*return*/, {
                            init: init,
                            request: request,
                            response: response,
                            data: data,
                        }];
                case 6:
                    error_1 = _m.sent();
                    if (error_1 instanceof TravelError) {
                        throw error_1;
                    }
                    else {
                        throw new TravelError({
                            code: sourceCode,
                            message: (typeof error_1 === "string"
                                ? error_1
                                : error_1 === null || error_1 === void 0 ? void 0 : error_1.message) || "fetch failed",
                            url: url,
                            request: request,
                            partnerID: partnerID,
                        });
                    }
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    });
}
